const Events = Object.freeze({
    RESIZE: Symbol('resize'),
    TICK: Symbol('tick'),
    RESOURCES_READY: Symbol('resourceReady'),
    ITEM_HAS_FOCUS: Symbol('itemHasFocus'),
    ITEM_LOST_FOCUS: Symbol('itemLostFocus'),
    ITEM_DETAIL_OPEN: Symbol('itemDetailOpen'),
    ITEM_DETAIL_CLOSE: Symbol('itemDetailClose'),
    TRIGGER_MOVEMENT: Symbol('triggerMovement'),
    TELEPORT: Symbol('teleport'),
});

export default Events;
